<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [title]="'Job Backup Times'"
      [canGoBack]="true"
      [class]="extraClass" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>

    @if (loaded) {
      <tidy-card>
        <div style="display: flex; align-items: flex-start;">
          <tidy-image
            [src]="categoryImage"
            style="width:30px;" />
          <div style="display: flex; flex-direction: column; margin-left: 10px;">
            <tidy-row>
              <tidy-text
                [header]="serviceName | titlecase" />
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="(startDatetimeLocal | parseDateTime: 'ddd') + ' ' + (startDatetimeLocal | parseDateTime: 'MMM d') + (' at ' | translate) + (startDatetimeLocal | parseDateTime: 'h:mma')" />
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="addressName" />
            </tidy-row>
          </div>
        </div>
      </tidy-card>
      <tidy-row [align]="'center'">
        <tidy-text
          [body]="'If my Pro can\'t make this time, automatically find a new time for my job at one of these times:'" />
      </tidy-row>
      @for (date of backupTimes; track date) {
        <tidy-card>
          @if (!date.checked) {
            <tidy-row [alignLastItemRight]="true">
              <tidy-text
                [header]="date?.date | parseDateTime:'dddd MMM d':''" />
              <tidy-text
                [body]="'Add Backup Times'"
                (action)="addTimesToDate(date)"
                class="link" />
            </tidy-row>
          }
          @if (date?.checked) {
            <tidy-row>
              <tidy-text
                [header]="date?.date | parseDateTime:'dddd MMM d'" />
            </tidy-row>
            @for (time of date?.times; track time; let i = $index) {
              @if (i % 3 === 0) {
                <tidy-two-column-row style="margin-bottom: 5px;">
                  <tidy-checkbox
                    [items]="[time]"
                    [(checked)]="time.checked"
                    [initValue]="time.checked" />
                  @if (date?.times[i+1] !== undefined) {
                    <tidy-checkbox
                      [items]="[date?.times[i+1]]"
                      [checked]="date?.times[i+1].checked"
                      (checkedChange)="updateTimeChecked(date, i+1, $event)"
                      [initValue]="date?.times[i+1].checked" />
                  }
                  @if (date?.times[i+2] !== undefined) {
                    <tidy-checkbox
                      [items]="[date?.times[i+2]]"
                      [checked]="date?.times[i+2].checked"
                      (checkedChange)="updateTimeChecked(date, i+2, $event)"
                      [initValue]="date?.times[i+2].checked" />
                  }
                </tidy-two-column-row>
              }
            }
          }
        </tidy-card>
      }
      <tidy-error-message
        [text]="errorMessage" />
      <tidy-button
        [text]="'Save Changes'"
        [action]="boundSaveJobBackupTimes"
        class="primary" />
    }
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
